/**
 * 에러 코드 → 영어 메시지(`generated/errorCatalog.generated.ts` 의 `message` 짝 · 판 17.1.3 · 253종).
 * 생성물은 고치지 않는다 — 한글 정본이 여전히 그쪽이고, 여기 없는 코드는 한글 카탈로그 · 서버 문구로 떨어진다.
 * 용어는 `docs/i18n-glossary-en.md`(작업 = Task). 🔴 HTTP 상태 꼬리(`(409)`)와 규칙 ID 는 옮기지 않았다.
 */
export const ERROR_MESSAGES_EN: Readonly<Record<string, string>> = {
  COMM_TIMEOUT: 'Communication response timed out',
  COMM_UNREACHABLE: 'Communication failed — could not connect',
  RS232_BCC_FAIL: 'RS-232 checksum (BCC) failed',
  MQTT_DISCONNECT: 'Lost connection to the equipment control network',
  ENV_SENSOR_OFFLINE: 'Environment sensor not responding (no heartbeat / LWT)',
  LINK_ACK_STALL: 'Commands not accepted while waiting for a link acknowledgement',
  LINK_BACKLOG: 'Unacknowledged responses are queued on the device',
  LINK_FRAME_TRUNCATED: 'Device response was cut off at the length limit',
  LINK_NAK_EXHAUSTED: 'Device keeps rejecting the command frame (retries exhausted)',
  LINK_PROTOCOL_MISMATCH: 'Device communication mode does not match the software protocol',
  LINK_RESPONSE_INVALID: 'Device response frame is invalid',
  MODULE_LINK_AUTH_FAILED: 'Internal certificate check failed — module link authentication denied',
  CHAMBER_ISOLATION_FAIL:
    'Could not isolate the failed chamber — not returned to its original tray slot',
  LOAD_OVERDUE: 'Loading overdue — manual load wait exceeded the time limit',
  UNLOAD_OVERDUE: 'Unloading overdue — unload wait exceeded the time limit',
  WASTE_FULL: 'Waste container full',
  WASTE_NEAR_FULL: 'Waste container nearly full — empty it to keep running without a stop',
  UNLOAD_PENDING: 'A tray is ready at the unload position',
  HANDOFF_POINT_OCCUPIED_AT_START: 'Cannot start the task — a tray remains at a transfer position',
  HANDOFF_POINT_OCCUPIED: 'Handoff point occupied — a tray is already at the destination',
  REAGENT_EXPIRED_AT_START:
    'Cannot start the task — a reagent is past its expiry or open-use period',
  REAGENT_EXPIRED_IN_RUN:
    'Reagent use period expired — dispensing stopped. Replace the reagent, then resume',
  ENV_OUT_OF_RANGE: 'Ambient temperature, humidity, or light is out of range',
  SAFETY_NOT_CLEARED:
    'Safety clear refused — physical safety conditions remain (E-Stop button, interlock, etc.)',
  SAFETY_TERMINAL_SERVICE_REQUIRED:
    'Safety clear not possible — SafeShutdown state. Service inspection required',
  STOPS_CHANGED: 'The list has changed — review the holds again before releasing',
  HW_E_STOP: 'Emergency stop button was pressed',
  SW_E_STOP: 'Software emergency stop is active',
  MODULE_STOP_NOT_CONFIRMED:
    'Some parts did not confirm the stop — check the equipment and send the stop again',
  TEMP_OUT_OF_RANGE: 'Chamber reaction temperature is out of range',
  SAFETY_SELFTEST_FAIL: 'Safety device self-test failed — operation is not possible',
  LIGHT_LEAK: 'Light has leaked into the dark chamber',
  INTERLOCK_OPEN: 'Module door is open',
  POWER_LOSS: 'Power was lost',
  INTERNAL_ERROR: 'Internal error in the equipment driver',
  GRIPPER_DROP: 'The gripper dropped what it was holding',
  CENT_IMBALANCE: 'Centrifuge rotor is out of balance',
  ROBOT_COLLISION: 'Robot collided or moved out of its allowed range',
  HW_FAULT: 'Permanent hardware failure',
  COMM_LOST_PERMANENT: 'Communication permanently lost — declared final by service diagnostics',
  MODULE_CONTRACT_VIOLATION: 'Module command contract violated — service inspection required',
  AUDIT_CHAIN_CORRUPTED:
    'Audit record integrity check failed — records changed or the chain is broken',
  CENT_SPEED_FAIL: 'Target RPM not reached or lost',
  CENT_REACH_FAIL: 'Centrifuge Cartesian robot cannot reach the target position',
  CENT_SLIDE_FAIL: 'Tray transfer failed',
  CENT_ROTATE_FAIL: 'Gripper rotation axis failed to reach its target',
  CENT_ROTOR_NOT_INDEXED: 'Rotor slot not indexed after rotation',
  ASM_UV_LAMP_FAIL: 'UV lamp did not light',
  ASM_SLIDE_FAIL: 'Tray transfer failed',
  ASM_ROTATE_FAIL: 'Chamber rotation (180°) failed',
  ASM_REACH_FAIL: 'Assembler Cartesian robot cannot reach the target position',
  TC_DEPLETED: 'Thickness Controllers depleted — the stock is less than the task requires',
  ASM_TC_ALIGN_FAIL: 'TC alignment failed — not seated correctly in the holder',
  STAIN_SHAKE_FAIL: 'Shaker below target speed or stopped',
  STAIN_LATCH_FAIL: 'Latch failed — shaker labware latch',
  STAIN_SLIDE_FAIL: 'Slider transfer failed',
  TIP_PICKUP_FAIL: 'Tip pickup failed',
  TIP_DISCARD_FAIL: 'Tip discard failed — a tip remains on the dispenser',
  STAIN_REACH_FAIL: 'Stainer cannot reach the target position',
  STAIN_INIT_FAIL: 'Dispenser initialization failed — command received while uninitialized',
  LLD_BOTTOM_REACHED: 'Liquid level search reached the bottom of the container',
  LLD_CALIBRATION_FAIL: 'Liquid level detection adjustment failed',
  LLD_NO_DETECT: 'Liquid level not detected',
  TIP_NOT_REGISTERED: 'Tip detected but its type is not registered',
  TIP_RESIDUAL_LIQUID: 'Residue from the previous work remains in the tip',
  TIP_TYPE_INCOMPATIBLE: 'Tip type does not suit the liquid level detection method',
  TIP_VOLUME_EXCEEDED: 'Requested volume exceeds the tip or plunger limit',
  PIPETTING_SEQUENCE_INVALID: 'This pipetting command cannot be accepted in the current state',
  DISPENSE_CLOG: 'Dispenser clogged',
  DISPENSE_FOAM: 'Foam detected during dispensing',
  LIQUID_ABSENT: 'No reagent detected before dispensing',
  REAGENT_TEMP_EXCURSION:
    'Reagent storage temperature excursion — reservoir temperature is outside the allowed deviation',
  REAGENT_TEMP_NEAR_LIMIT:
    'Reagent storage temperature nearing its limit — act now to keep running without a stop',
  TEMP_EXCURSION:
    'Chamber reaction temperature excursion after reaching the set point. The process does not stop',
  REAGENT_LIGHT_EXPOSURE:
    'Fluorescent reagent exposed to light — check for signal loss, then continue or re-stain',
  REAGENT_EXHAUSTED_IN_RUN: 'Reagent exhausted — task paused. Replenish, then resume',
  REAGENT_TEMP_NOT_REACHED:
    'Reagent storage temperature not reached yet — you can start once it is reached',
  TIP_DEPLETED: 'Tip rack depleted',
  TIP_NOT_MOUNTED: 'No tip mounted — aspirate and dispense are not performed',
  TIP_LOST_DURING_PIPETTING:
    'Tip missing after aspirate or dispense — it came off during the operation',
  REAGENT_VOLUME_LOW: 'Reagent is low and may run out during the task',
  ROBOT_REACH_FAIL: 'Robot cannot reach the position',
  AUX_STATION_NOT_REACHED:
    'Auxiliary axis is not at the required coordinate for the target — robot start refused',
  ROBOT_PROTECTIVE_STOP: 'Robot protective stop — remove the cause, then clear it',
  ROBOT_SAFETY_LIMIT_VIOLATION:
    'Robot safety limit violated — clear it explicitly and pass the readiness check again',
  ROBOT_NOT_READY: 'Robot is not ready to operate — check power, brakes, and backdrive',
  ROBOT_RTDE_BUSY: 'RTDE session in use — could not acquire control',
  ARM_NOT_IN_TRAVEL_POSE: 'Arm is outside the tray travel pose — auxiliary axis travel refused',
  ARM_RETREAT_NOT_POSSIBLE: 'Arm position unknown — cannot return to the transfer standby position',
  ROBOT_LOCAL_MODE: 'Robot is in local mode — switch to remote control to run commands',
  ROBOT_RUNTIME_FAIL: 'Robot control program failed to resume',
  ROBOT_CTRL_LINK_LOST: 'Robot control link lost — reconnecting',
  ROBOT_CLEARANCE_UNVERIFIED:
    'Could not confirm the arm is clear after parking — check the arm position, then resume',
  AUX_AXIS_FAULT: 'Travel axis servo error — drive system inspection required',
  REQUEST_VALIDATION_FAIL:
    'Request does not match the contract schema (required fields, types, formats)',
  ORCHESTRATOR_INTERNAL_ERROR: 'Internal server error — the request could not be processed',
  SYSTEM_MODE_CHANGE_REJECTED: 'The operating mode cannot be changed now',
  PREFLIGHT_BLOCK:
    'Pre-check not passed (reagent, storage temperature, tips, TC, waste, calibration, temperature, communication, teaching)',
  POSITION_UNTAUGHT: 'Cannot start — a position used by the task has not been taught',
  POSITION_TEACH_DIVERGED: 'Cannot start — a module teaching value differs from the integrated PC',
  POSITION_PENDING_UNSENT: 'Cannot start — some coordinates have not been applied to the module',
  MODULE_BINDING_UNRESOLVED:
    'Required equipment cannot be assigned — none registered or more than one of a type. Check equipment registration',
  DISPATCH_CANCELLED_BY_SAFETY_GATE:
    'Dispatch cancelled because a safety state is active — clear it, then resume',
  REDISPATCH_REJECTED_EXPANSION_DRIFT:
    'Re-dispatch refused because the expansion rules changed — decide whether to continue or restart',
  SCHEDULER_TERMINATED:
    'The scheduler has stopped — check the cause and clear the terminal state to run again',
  CORE_WATCHDOG_ALERT:
    'The core server is not responding or the scheduler has been stopped for a long time — check the integrated PC',
  SCHEDULER_STALLED: 'The scheduler has stopped — this alert clears once it runs again',
  BATCH_STALLED: 'The task stopped because something it was waiting for did not arrive',
  BATCH_DISPATCH_HALTED: 'The task has stopped',
  BATCH_PAUSE_DELAY_WARN: 'The task has been paused for a long time (over 80% of the allowed time)',
  BATCH_PAUSE_DELAY_EXCEEDED:
    'The task has been paused past the allowed time — sample disposal is recommended',
  ALARM_NO_REMOTE_RECIPIENT: 'No remote recipient to notify when a task stops',
  RECIPE_TEACHING_PREMISE_DIFFERS:
    'Teaching values assumed by the recipe differ from the current ones',
  MODULE_EXECUTION_FAILED_HALT:
    'A module execution failed and the task stopped — check the cause code and stop reason',
  SAMPLE_AWAITING_DECISION:
    'A sample is awaiting a decision — choose [Reuse] or [Discard] before the deadline',
  SAMPLE_DECISION_RELAY_FAIL:
    'Could not relay the sample decision to the module — check the module and decide again',
  SAMPLE_DECISION_STALLED:
    'The task stopped because a sample decision is unfinished — check the sample and decide',
  SAMPLE_NOT_AWAITING_DECISION: 'This sample cannot be decided now — check its status',
  SAMPLE_DECISION_SLOT_UNRESOLVED:
    'Cannot reuse because the original slot is unknown — choose [Discard] or check the recipe labware definition',
  BATCH_EXECUTION_CANCEL_UNCONFIRMED:
    'Could not confirm the finished task’s execution was cancelled — check the equipment and cancel it from equipment control',
  BATCH_EXECUTION_FOREIGN:
    'An execution not sent by this task ran on the module — the task continues',
  BATCH_EXECUTION_REPLACED:
    'The same command ran again (the earlier run did not move) — the task continues',
  BATCH_EXECUTION_REPEATED:
    'The same command ran again (the earlier run already moved; the motion may repeat) — the task continues',
  BATCH_EXECUTION_UNCLASSIFIED:
    'Two module motions appeared after one command — the task continues',
  HANDOFF_RESOURCE_IN_USE:
    'Another transfer is using that robot or position — if isolated, confirm physically and [Clear]',
  RECIPE_IMMUTABLE: 'A recipe in use cannot be changed — duplicate it as a draft to edit',
  BATCH_COMMAND_NOT_ALLOWED: 'This task command cannot be accepted in the current state',
  MODULE_MODE_CHANGE_REJECTED: 'Cannot switch to standalone mode while a cycle is in progress',
  RECIPE_VALIDATION_FAIL: 'Recipe values are invalid (range, order, time)',
  CAL_EXPIRED: 'Calibration has expired',
  CAL_NOT_PERFORMED: 'No required calibration record — perform the first calibration',
  CHECKPOINT_RESTORE_PARTIAL:
    'Cannot continue as-is — equipment state at the stop could not be compared with the current state',
  DB_WRITE_FAIL: 'Database write failed',
  BACKUP_FAIL: 'Scheduled backup failed',
  ALERT_DELIVERY_FAILED: 'Remote alarm delivery failed — could not reach any of the recipients',
  TIME_SYNC_DRIFT: 'Equipment clock is out of sync',
  MODULE_INCOMPATIBLE:
    'Module version or settings do not match — not admitted to integrated operation',
  MODULE_VERSION_DRIFT:
    'Module version differs from what the integrated PC expects — integrated operation is not affected',
  MODULE_DELETE_REJECTED:
    'Cannot delete the module — check service state, open tasks, and executions',
  MODULE_REGISTRATION_REJECTED:
    'Cannot register the module — check type occupancy, address, and broker account',
  POSITION_REGISTRY_REJECTED:
    'Cannot change the position registry — check existing names, protected points, and recipes in use',
  TEACH_NOT_ALLOWED:
    'Teaching is not allowed now — check operating mode, control owner, and module state',
  BROKER_ACCOUNT_CHANGE_REJECTED:
    'Cannot change the broker account now — check tasks, replacements in progress, and the target account',
  MODULE_BROKER_CHANGE_REJECTED:
    'Cannot change broker settings now — try again after the execution ends',
  BROKER_CLIENT_ID_MISMATCH:
    'A broker account connected with a client ID other than its own module ID',
  BROKER_ACCOUNT_COPY_MISMATCH: 'The broker account copy differs from the broker',
  BROKER_CREDENTIAL_UNCONFIRMED:
    'Broker credentials changed, but the module’s connection with them could not be confirmed',
  BROKER_CLEANUP_INCOMPLETE:
    'Broker account cleanup is unfinished — check the roles in the account table',
  MODULE_RESET_IN_BATCH:
    'A module assigned to a running task dropped out by connection reset — stop the task or re-register the module',
  LABWARE_VALIDATION_FAIL: 'Labware definition is invalid — check structure, uniqueness, and order',
  ESTOP_FANOUT_INCOMPLETE:
    'Emergency stop was sent, but some modules did not confirm — check on site',
  ESTOP_STATE_NOT_RECORDED:
    'Emergency stop was sent, but the safety state was not recorded — equipment is stopped even if the screen shows normal',
  EXPORT_VALIDATION_FAIL:
    'Export request is invalid — check target, format, period, and export reason',
  ROBOT_HANDOFF_TIMEOUT:
    'Handoff timed out — occupancy released; check for physical interference, then resume',
  REAGENT_LOT_ALREADY_EXISTS: 'Reagent lot already registered — each lot registers once',
  REAGENT_LOT_NOT_REGISTERED: 'A reagent lot used by the recipe is not registered',
  REAGENT_LOT_ALREADY_OPENED: 'Reagent lot already opened — it cannot be reopened',
  REAGENT_SHORTAGE_AT_START: 'Cannot start the task — not enough reagent (Pre-check)',
  STAINING_TARGET_AMBIGUOUS:
    'More than one stainer is on — cannot tell which one to measure reagent on',
  TIP_SHORTAGE_AT_START: 'Cannot start the task — not enough tips',
  TC_SHORTAGE_AT_START: 'Cannot start the task — not enough TCs',
  SEQUENCE_UNSUPPORTED_AT_START:
    'Cannot start the task — the recipe has a motion the module cannot perform',
  TEMPERATURE_OUT_OF_CAPABILITY_AT_START:
    'Cannot start the task — this module cannot reach the recipe’s shaking temperature',
  DISPENSE_RESOLUTION_OUT_OF_CAPABILITY_AT_START:
    'Cannot start the task — the recipe volume does not fit this module’s dispense resolution',
  TC_STOCK_OUT_OF_CAPABILITY_AT_START:
    'Cannot start the task — the recipe needs more TCs than the assembly module can hold',
  BATCH_SAMPLE_SET_UNSUPPORTED:
    'Cannot start the task — the centrifuge cannot run with this sample set',
  DEVICE_NOT_READY_AT_START: 'Cannot start the task — module parts are not ready',
  PREFLIGHT_MODULE_NOT_IDLE: 'Cannot start the task — a module is not idle',
  PREFLIGHT_CONSUMABLE_UNVERIFIED:
    'The equipment cannot verify consumable levels — check them visually before continuing',
  PREFLIGHT_TRAY_NOT_LOADED: 'Cannot start the task — tray not loaded',
  PREFLIGHT_SAFETY_STOP: 'Cannot start the task — safety stop active',
  PREFLIGHT_GRIP_DROP_UNRECOVERED:
    'Cannot start the task — what the gripper dropped has not been recovered',
  USER_VALIDATION_FAIL: 'User account validation failed (fields, role, format)',
  SAMPLE_ALREADY_EXISTS: 'Duplicate sample ID — this sample is already registered',
  USER_ALREADY_EXISTS: 'Duplicate username — this login ID already exists',
  ACCOUNT_LOCKED: 'This account cannot log in now — contact an administrator',
  AUTH_FAILED: 'Authentication failed — check your account and password, or log in again',
  BREACHED_PASSWORD: 'This password is known to be leaked — use a different one',
  WEAK_PASSWORD: 'Password policy violation (complexity, length)',
  CURRENT_PASSWORD_MISMATCH:
    'Current password does not match — this failure counts toward login lockout',
  LAST_ADMIN_PROTECT: 'Refused to deactivate, demote, or lock the last active administrator',
  INSUFFICIENT_ROLE:
    'Insufficient role — only operator or admin can acquire the Control Lock or change state',
  CONTROL_LOCK_HELD:
    'Another user is in control — wait for release or have an administrator clear it',
  MODULE_HALTED: 'Module is stopped and does not accept commands',
  MODULE_MODE_UNEXPECTED: 'Device is in an unexpected operating mode',
  MODULE_NOT_INITIALIZED: 'Module is not initialized',
  MODULE_TEST_MODE_ACTIVE: 'Device is in test mode — commands are not executed',
  SUPPLY_VOLTAGE_OUT_OF_RANGE: 'Supply voltage is out of range',
  COUNTER_SAVE_MISSED: 'Power was lost before the life counter was saved',
  MODULE_LOCAL_MODE: 'Module is in standalone (local) mode — state change request refused',
  MODULE_STANDALONE_RUN: 'Module is running standalone — handoff and holder moves are not accepted',
  TIMED_ATOM_RESUME_UNAVAILABLE:
    'The interrupted timed step cannot continue with only its remaining time',
  MODULE_Z_NOT_SAFE_FOR_XY: 'Horizontal move not made — Z could not rise to the safe height',
  MODULE_Z_BELOW_FLOOR: 'Z target is below the floor limit — Z move refused',
  MODULE_Z_ROLE_UNDEFINED: 'Height role is not in the module’s height rules — Z move refused',
  MODULE_EXPECTED_MISMATCH: 'Move target differs from the reference beyond the limit — not moved',
  MOTOR_FRAME_UNTAUGHT: 'Robot origin or motion offset not recorded — coordinate move not made',
  MODULE_BUSY: 'Module is busy with another motion — try again shortly',
  MODULE_RESTARTED_SINCE_PLAN:
    'Module restarted after the block was planned — read its state and send again',
  MODULE_RESTARTED_DURING_EXECUTION:
    'Module restarted and interrupted the execution — resend from the interrupted step',
  MODULE_IN_ERROR: 'Module is in error — open recovery, then send again',
  MODULE_ABORTED: 'Module stopped by cancel — clean up and return home',
  MODULE_INTERRUPTED:
    'Module is waiting for the interrupted execution to continue — only that execution or the same task is accepted',
  MODULE_OFF_INCOMPLETE:
    'Some devices could not be turned off after cancel — check before touching the equipment',
  MODULE_HANDOFF_DOOR_OPEN: 'Handoff opening in progress — close the door and try again',
  INITIALIZE_ROBOT_HOLDING_TRAY:
    'Not initialized — the robot is holding something. Clear it and try again',
  TRAY_CONFIRM_LEDGER_OPEN: 'The task ledger has an open entry — confirm through the ledger',
  MODULE_FRONT_DOOR_OPEN: 'Front door is open — close it and send again',
  HANDOFF_TRAY_AT_FRONT: 'Tray is already at the front — the robot cannot pick it up',
  TRAY_CONFIRM_DOOR_OPEN: 'Front door is open — close it, then confirm',
  MODULE_SAFETY_HOLD_ACTIVE: 'Safety stop hold active — clear the safety stop and try again',
  MODULE_PROTECTIVE_STOP_ACTIVE:
    'Collaborative robot protective stop active — clear it, then resume',
  MODULE_NOT_IN_LOCAL_MODE:
    'Not under local control — switch the module to standalone mode and try again',
  MODULE_EXECUTION_ALREADY_TERMINAL: 'Execution already finished — nothing to cancel',
  PROCESS_ASSIGNMENT_NOT_RESUMABLE: 'Process already finished — nothing to continue',
  MODULE_ENTRYPOINT_NOT_SERVED:
    'This module type does not accept this entry point — send it to the responsible module',
  MODULE_COMPILER_ABSENT: 'This release has no recipe compiler — contact service',
  MODULE_DRIVER_NOT_WIRED: 'This release has no equipment driver connected — contact service',
  MODULE_INTERNAL_ERROR: 'Internal module error — the request could not be processed',
  MODULE_ROLE_NOT_PRESENT:
    'This role or resource does not exist on this module type — do not send this call',
  MODULE_POSITION_NOT_OWNED: 'This module does not own this point ID',
  CHAMBER_BUNDLE_CONFLICT:
    'Another sample record remains on that tray or position — clear it first',
  HANDOFF_ROUND_MISMATCH:
    'Handoff confirmation does not match the last confirmation at that position',
  POSITION_VERSION_CONFLICT:
    'That point was re-taught in the meantime — read the current value and choose again',
  CHAMBER_DECISION_REJECTED: 'A decision for that slot cannot be accepted now',
  CHAMBER_DECISION_PENDING:
    'Tray not moved — a sample is awaiting a decision. Decide and send again',
  DOOR_FAIL: 'Door drive failed',
  MODULE_PARAM_REJECTED: 'Module rejected the parameter',
  ROBOT_HOME_FAIL: 'Return to home failed',
  AXIS_DRIVE_FAULT: 'Cartesian axis drive error — drive system inspection required',
  AXIS_MOTION_TIMEOUT: 'Axis move timed out — the axis has stopped',
  GRIPPER_INIT_FAIL: 'Gripper zero calibration failed',
  GRIPPER_MISS: 'Gripper did not detect the chamber',
  GRIPPER_RELEASE_HELD: 'Gripper opened, but the object is still held',
  GRIPPER_ROTATE_STALLED: 'Gripper rotation axis stalled (reported by the device)',
  GRIPPER_TIMEOUT: 'Gripper motion timed out',
  PREFLIGHT_BAY_OCCUPIED:
    'An object is on a position that must be empty — remove it and check again',
  PREFLIGHT_ITEM_MISSING: 'A required item is not at its position — place it and check again',
  PREFLIGHT_COUNT_MISMATCH: 'The placed count differs from the recipe — correct it and check again',
  PREFLIGHT_POSE_INVALID: 'An item is out of position — replace it and check again',
  PREFLIGHT_PLAN_COORD_MISMATCH:
    'Plan coordinate mismatch — module well coordinates differ from the integrated PC preview beyond the limit',
  PREFLIGHT_PROCESS_UNRESOLVED:
    'Cannot start the task — the recipe process cannot be completed end to end',
  PREFLIGHT_WASTE_NOT_EMPTIED: 'Cannot start the task — the waste container has not been emptied',
  PREFLIGHT_DOOR_OPEN: 'A door is not closed — close it and check again',
  VISION_DEVICE_FAULT_AT_START: 'Vision device fault — cannot inspect, so the task cannot start',
  VISION_INSPECT_INCONCLUSIVE_AT_START:
    'Cannot start the task — the vision inspection result is inconclusive',
  PREFLIGHT_CHAMBER_DAMAGED: 'Chamber damaged — replace it and start again',
  PREFLIGHT_CHAMBER_LEAKING:
    'Chamber leaking — replace it, clean the affected area, and start again',
  VISION_DEVICE_FAULT_IN_RUN:
    'Vision device fault — chamber inspection not possible, process stopped',
  VISION_INSPECT_INCONCLUSIVE_IN_RUN:
    'Chamber inspection inconclusive — check and decide whether to resume',
  CHAMBER_DAMAGED: 'Chamber damaged — isolate it to its original tray slot',
  CHAMBER_LEAKING:
    'Chamber leaking — isolate it to its original tray slot and clean the contamination path',
  ITEM_MISSING:
    'Something expected at the inspection position is missing — check and decide whether to resume',
}
